import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// import { Pokemon } from './types';

export const stripeApi = createApi({
  reducerPath: 'stripeApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['stripe'],
  endpoints: (builder) => ({
    refund: builder.mutation({
      query: (body) => {
        return {
          url: spotFinder.StripeController.refund,
          method: 'POST',
          body: body.payload,
        };
      },
    }),
    createTransfer: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.StripeController.createTransfer}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useRefundMutation, useCreateTransferMutation } = stripeApi;
